export const bell = () => (
  <path
    d="M13.73 21a2 2 0 01-3.46 0M18 8A6 6 0 106 8v5l-3 4h18l-3-4V8z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
